import React, { PropTypes } from 'react'
import classNames from 'classnames'
import { identity } from 'lodash'
import "./PaintSwatch.css"

const PaintSwatch = ({ paint, selected, onClick = identity }) => (
  (paint && paint.colorCode) ?
    <div className={classNames({
      'paint-swatch': true,
      'selected': selected,
      'translucent': paint.isTranslucent
    })}
      onClick={() => onClick(paint)}
      style={{ background: `#${paint.colorCode}` }}
      title={paint.title || paint.label}
    >
    </div>
    :
    <div className={classNames({
      'paint-swatch': true,
      'no-selection': true
    })}
	onClick={() => onClick(paint)}
    title="No Color"
    >
    </div>
)

PaintSwatch.propTypes = {
  paint: PropTypes.shape({
    id: PropTypes.number,
    isTranslucent: PropTypes.bool,
    colorCode: PropTypes.string,
  }),
  selected: PropTypes.bool,
  onClick: PropTypes.func,
}

export default PaintSwatch;